import React, { Component } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import moment from 'moment';

import { deleteQrCode } from '../../mutations';
import { StoreProvider, Label, Dialog } from '../../components';

function formatDate(date) {
  return moment(date).format('MM-DD-YYYY h:mm a');
}

const Group = ({ title, className, children }) => {
  return (
    <div className={`form-group ${className}`}>
      <h3>{title}</h3>
      <div>{children}</div>
    </div>
  );
};

const Row = ({ className, children }) => {
  return <div className={`form-group-row ${className}`}>{children}</div>;
};

const Column = ({ className, children }) => {
  return <div className={`form-group-column ${className}`}>{children}</div>;
};

const Value = ({ className, attr, title, children }) => {
  return (
    <div className={`${className}`}>
      <Label attr={attr} text={title} />
      {children}
    </div>
  );
};

const Image = ({ attr, title, src }) => {
  return (
    <div className="qr-code-image">
      <div className="qr-code-image-header">
        <Label attr={attr} text={title} />
      </div>
      <img src={src} />
    </div>
  );
};

export class QrCodeShowView extends Component {
  state = {
    showsDeleteDialog: false,
  };

  handleCancelDelete = (event) => {
    event.preventDefault();
    event.stopPropagation();
    this.setState({ showsDeleteDialog: false });
  };

  handleConfirmDelete = (event) => {
    event.preventDefault();
    event.stopPropagation();
    this.setState({ showsDeleteDialog: false });

    const { lists, qrCode, relay, history } = this.props;
    deleteQrCode(relay.environment, qrCode.id, lists.id, {
      onCompleted: () => history.push('/qr-codes'),
      onError: this.handleSubmitFailure,
    });
  };

  handleSubmitFailure = (err) => {
    console.error(err.message);
  };

  render() {
    const { showsDeleteDialog } = this.state;
    const { qrCode } = this.props;

    return (
      <div className="store">
        <Dialog
          className="deletion"
          isOpen={showsDeleteDialog}
          message={`'Are you sure you want to remove QR code ${qrCode.sign}?`}
          onConfirm={this.handleConfirmDelete}
          onCancel={this.handleCancelDelete}
        />
        <div className="header">
          <h2>QR code details</h2>
          <a
            className="button delete"
            onClick={() => this.setState({ showsDeleteDialog: true })}
          >
            Delete QR code
          </a>
        </div>

        <Group>
          <Row>
            <Column>
              <Value
                className="qr-code-createdAt"
                attr="ceatedAt"
                title="Created at"
              >
                {formatDate(qrCode.createdAt)}
              </Value>
              <Value className="qr-code-link" attr="link" title="Link">
                {qrCode.link}
              </Value>
              <Value className="qr-code-sign" attr="sign" title="QR code sign">
                {qrCode.sign}
              </Value>
              <Value
                className="qr-code-imageLink"
                attr="imageLink"
                title="Link to image"
              >
                {qrCode.qrCodeUrl}
              </Value>
            </Column>
          </Row>
          <Row>
            <Image attr="Image" title="QR code Image" src={qrCode.qrCodeUrl} />
          </Row>
        </Group>
      </div>
    );
  }
}

const QrCodeShowContainer = createFragmentContainer(QrCodeShowView, {
  qrCode: graphql`
    fragment QrCodeShow_qrCode on QrCode {
      id
      createdAt
      link
      sign
      qrCodeUrl
    }
  `,
  lists: graphql`
    fragment QrCodeShow_lists on Lists {
      id
      qrCodes(first: 100) {
        edges {
          node {
            id
            createdAt
            link
            sign
          }
        }
      }
    }
  `,
});

export default class QrCodeShow extends Component {
  render() {
    return (
      <StoreProvider
        container={QrCodeShowContainer}
        modern
        query={graphql`
          query QrCodeShowQuery($qrCodeId: ID!) {
            lists {
              ...QrCodeShow_lists
            }
            qrCode: qrCode(id: $qrCodeId) {
              ...QrCodeShow_qrCode
            }
          }
        `}
      />
    );
  }
}
